// =============================================================================
// SimSense Platform — Join Team Page
// =============================================================================

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../utils/api";

export function TeamJoin() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");

  useEffect(() => {
    async function join() {
      try {
        const result = await api<any>(`/api/teams/join/${token}`, {
          method: "POST"
        });
        setStatus("success");
        setTimeout(() => navigate(`/teams/${result.teamId}`), 2000);
      } catch (err) {
        console.error("Failed to join team", err);
        setStatus("error");
      }
    }
    join();
  }, [token, navigate]);

  return (
    <div style={{ textAlign: "center", padding: "100px 40px" }}>
      {status === "loading" && (
        <>
          <h2 style={{ marginBottom: "16px" }}>Joining Team...</h2>
          <p style={{ color: "var(--text2)" }}>Validating invite token and adding you to the team roster.</p>
        </>
      )}
      {status === "success" && (
        <>
          <h2 style={{ marginBottom: "16px", color: "var(--accent)" }}>Welcome to the Team! 🏁</h2>
          <p style={{ color: "var(--text2)" }}>You've successfully joined. Redirecting you to the team dashboard...</p>
        </>
      )}
      {status === "error" && (
        <>
          <h2 style={{ marginBottom: "16px", color: "#f87171" }}>Invalid Invite Link</h2>
          <p style={{ color: "var(--text2)", marginBottom: "32px" }}>The invite token is either invalid, expired, or has been revoked.</p>
          <button 
            onClick={() => navigate("/teams")}
            style={{ padding: "10px 20px", background: "var(--accent)", color: "#fff", border: "none", borderRadius: "4px", fontWeight: 600, cursor: "pointer" }}
          >
            Go to My Teams
          </button>
        </>
      )}
    </div>
  );
}
